import {
  getShouldShowBannerNotificationsUX,
  getShouldShowReaderBlur,
  handleBannerNotification,
  logViewRestrictionEvent,
  ALLOWED_CONTENT_COUNT_WITHOUT_SUBSCRIPTION,
  CONTENT_COUNT_TO_START_RENDERING_BANNER_NOTIFICATIONS,
} from './content-gate-common';
import { resolve as setViewRestrictionState } from './view-restriction-state';
import Model from './content-gate-model';
import { player } from 'app/assets/javascripts/new_player/selectors';
import { isLocalStorageEnabled } from 'app/assets/javascripts/utils/localstorage';

window.addEventListener('DOMContentLoaded', () => {
  if (!window.feature_flags.viewRestrictionWithoutSubscriptionAfterFive) {
    // Disabled by feature flag, bail early
    setViewRestrictionState({ state: null, counter: null });
    return;
  }

  const slideshare_object = window.slideshare_object;
  const slideshow = slideshare_object && slideshare_object.slideshow;
  if (!slideshow) {
    // no slideshow on this page
    setViewRestrictionState({ state: null, counter: null });
    return;
  }

  if (!isLocalStorageEnabled()) {
    // with local storage disabled, we cannot keep track of viewed content
    setViewRestrictionState({ state: 'not supported', counter: null });
    return;
  }

  if (!slideshow.view_restriction_eligible) {
    // Slideshow is not eligible for view restriction.
    setViewRestrictionState({ state: 'unrestricted', counter: null });
    return;
  }

  let model = new Model();
  model.trackView(slideshow.id);
  logViewRestrictionEvent(model.numberOfViewedDocuments);
  const contentAccountGateDataLen = model.numberOfViewedDocuments;

  setViewRestrictionState({
    state: getViewRestrictionState(model.numberOfViewedDocuments),
    counter: model.numberOfViewedDocuments,
  });
  applyViewRestrictionUx(contentAccountGateDataLen);
});

function applyViewRestrictionUx(contentAccountGateDataLen) {
  const slideshare_object = window.slideshare_object;
  const { shouldShowBanner, remainingDocCount } =
    getShouldShowBannerNotificationsUX(
      ALLOWED_CONTENT_COUNT_WITHOUT_SUBSCRIPTION,
      contentAccountGateDataLen,
      CONTENT_COUNT_TO_START_RENDERING_BANNER_NOTIFICATIONS
    );
  const shouldBlurReader = getShouldShowReaderBlur(
    ALLOWED_CONTENT_COUNT_WITHOUT_SUBSCRIPTION,
    contentAccountGateDataLen
  );

  // Handle UX
  handleBannerNotification(
    shouldShowBanner,
    remainingDocCount,
    slideshare_object
  );

  if (shouldBlurReader) {
    player.attr('data-shouldblurreader', shouldBlurReader);
  }
}

function getViewRestrictionState(currentCount) {
  const contentLimitForBanner =
    ALLOWED_CONTENT_COUNT_WITHOUT_SUBSCRIPTION -
    CONTENT_COUNT_TO_START_RENDERING_BANNER_NOTIFICATIONS;

  if (currentCount < contentLimitForBanner) {
    return 'unrestricted';
  } else if (
    currentCount >= contentLimitForBanner &&
    currentCount < ALLOWED_CONTENT_COUNT_WITHOUT_SUBSCRIPTION
  ) {
    return 'warning';
  } else {
    return 'restricted';
  }
}
